import { useEffect } from "react";

import { OutcomeScoreTable } from "./OutcomeScoreTable";
import { PagePointTable } from "./PagePointTable";
import { SectionScoreTable } from "./SectionScoreTable";
import { useFetchAssessmentBaseData, useFetchAssessmentData } from "./assessment-data";
import { useSectionScoreData } from "./hooks";

import { EmptyAssessmentDashboard } from "components/materials/section/assessment/EmptyAssessmentDashboard";
import { storeApi, useAppSelector } from "store/index";
import { selectCurrentSection } from "store/selectors";
import { isSectionScoreDataSufficient } from "utils/assessment";
import { useSectionScoreTable } from "utils/hooks/use-section-score-table";

export const SectionScoreDashboard = () => {
  const section = useAppSelector(selectCurrentSection);
  const sectionId = section?.id;

  const {
    studentPointsPerPageCSVData,
    studentPointsPerPageTableRows,
    studentScoresPerOutcomeCSVData,
    studentScoresPerOutcomeTableRows,
    sectionStudents,
    sectionOutcomes,
    publishedPagesWithAssessments,
  } = useSectionScoreData();

  useFetchAssessmentBaseData();
  useFetchAssessmentData();

  useEffect(() => {
    if (sectionId) {
      storeApi.page_outcomes.list({ section_id: sectionId });
      storeApi.page_group_users.list({ section_id: sectionId });
    }
  }, [sectionId]);

  // Use the SectionScore data that was already fetched from the server by SectionScoreTableProvider.
  const { rows: sectionScoreTableRows } = useSectionScoreTable();

  if (!section) {
    return null;
  }

  const noData =
    (!sectionScoreTableRows || !isSectionScoreDataSufficient(sectionScoreTableRows)) &&
    publishedPagesWithAssessments.length === 0 &&
    studentScoresPerOutcomeTableRows.every(
      (row) => row.outcomeScores.length === 0 || row.outcomeScores.every((score) => score === null),
    );

  if (noData) {
    return <EmptyAssessmentDashboard />;
  }

  return (
    <main className="assessment-dashboard">
      <SectionScoreTable section={section} sectionScoreTableRows={sectionScoreTableRows} />

      <PagePointTable
        publishedPagesWithAssessments={publishedPagesWithAssessments}
        sectionStudents={sectionStudents}
        studentPointsPerPageCSVData={studentPointsPerPageCSVData}
        studentPointsPerPageTableRows={studentPointsPerPageTableRows}
      />

      <OutcomeScoreTable
        sectionOutcomes={sectionOutcomes}
        studentScoresPerOutcomeCSVData={studentScoresPerOutcomeCSVData}
        studentScoresPerOutcomeTableRows={studentScoresPerOutcomeTableRows}
      />
    </main>
  );
};
